import React, { Component } from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import Pagination from './ui/Pagination';
import { pushHistoryState } from '../../helpers/routing';
import { USERS_LIST_PAGE_SIZE } from '../../constants/general';

export default class PaginationBaseComponent extends Component {
  static propTypes = {
    getDataAction: PropTypes.func.isRequired,
    pagesQuantity: PropTypes.number.isRequired
  };

  pageSize = USERS_LIST_PAGE_SIZE;

  getActivePage = () => {
    const { page } = url.parse(window.location.href, true).query;
    return !parseInt(page, 10) ? 0 : parseInt(page, 10) - 1;
  };

  pushUrl = url => pushHistoryState(url);

  _loadData (activePage = this.state.activePage, filter = {}) {
    return this.loadData(activePage, filter);
  }

  /**
   * @param {number} activePage
   * @param {object} filter
   * @param {string} filter.queryString
   * @param {string} filter.urlString
   * @param {string} filter.period
   * */
  loadData (activePage = this.state.activePage, filter = {}) {
    const { match: { url }, getDataAction } = this.props;
    const pageSize = this.pageSize;

    return getDataAction(activePage * pageSize, filter).then(data => {
      if (data) {
        const activePageValue = activePage + 1;

        if (activePage !== 0 && activePageValue > this.props.pagesQuantity) {
          return this.loadData(0, filter);
        }

        const filterQuery = (filter && filter.urlString) || '';
        const pageUrl = `${url}?page=${activePage + 1}` + filterQuery;

        this.pushUrl(pageUrl);
        this.setState({ activePage });
      }
    });
  };

  decreasePage = () => {
    if (this.state.activePage !== 0) {
      this.setState(prevState => ({
        activePage: prevState.activePage - 1
      }), this._loadData);
    }
  };

  increasePage = () => {
    const { activePage } = this.state;
    const { pagesQuantity } = this.props;
    if (activePage !== pagesQuantity - 1) {
      this.setState(prevState => ({
        activePage: prevState.activePage + 1
      }), this._loadData);
    }
  };

  handlePageChange = e => {
    const { value } = e.target;
    this.setState({
      activePage: value - 1,
      goToPageBtnIsShown: true
    });
  };

  goToPage = () => {
    this._loadData();
    this.setState({
      goToPageBtnIsShown: false
    });
  };

  renderPagination = () => {
    const { activePage, goToPageBtnIsShown } = this.state;
    const { pagesQuantity } = this.props;
    return (
      <Pagination
        activePage={activePage}
        goToPageBtnIsShown={goToPageBtnIsShown}
        pagesQuantity={pagesQuantity}
        decreasePage={this.decreasePage}
        handlePageChange={this.handlePageChange}
        goToPage={this.goToPage}
        increasePage={this.increasePage}
      />
    );
  };

  render () {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/PaginationBaseComponent.js